import { FC, SVGProps } from 'react';

export const CalendarTimeIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g opacity="0.5">
			<path
				d="M2.79492 7.43066H14.5687"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.3278 2.58337V4.73759"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.03894 2.58337V4.73759"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5716 8.85724V6.65707C14.5774 4.68895 13.3828 3.61768 11.4548 3.61768H5.91239C3.9895 3.61768 2.78906 4.68895 2.78906 6.65707V12.5811C2.78906 14.58 3.9895 15.676 5.91239 15.676H7.52513"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.2117 13.1856C15.2117 14.7852 13.9149 16.082 12.3146 16.082C10.715 16.082 9.41821 14.7852 9.41821 13.1856C9.41821 11.586 10.715 10.2885 12.3146 10.2885C13.9149 10.2885 15.2117 11.586 15.2117 13.1856Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.2147 13.9405L12.2988 13.3932V12.2162"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
